const deviceTypeOptions = [
    { value: 'PC', label: 'PC' },
    { value: '3', label: 'VR all-in-one' },
    { value: '4', label: 'Launcher' },
    { value: '5', label: 'Master' },
  ];

// PC子選項
export const pcSubOptions = [
  { value: '0', label: 'ACER' },
  { value: '1', label: 'VR LINK' },
  { value: '2', label: '2D VIEW' },
];

//所有選項的對應
export const allOptions = {
  '0': { label: 'PC - ACER' },
  '1': { label: 'PC - VR LINK' },
  '2': { label: 'PC - 2D VIEW' },
  '3': { label: 'VR all-in-one' },
  '4': { label: 'Launcher' },
  '5': { label: 'Master' }
};

export default deviceTypeOptions;
